import React from 'react'
import { Box, BoxProps as BoxBaseProps } from 'rebass'

interface BoxProps extends BoxBaseProps {
    key?: string
}

const Container: React.FC<BoxProps> = ({ children, ...props }) => (
    <Box maxWidth={1080} {...props}>
        {children}
    </Box>
)

export default Container
